import type { Purchase } from "@libs/platform-wire/purchase";
import { purchaseHeadline } from "@libs/buy-on-behalf-client/purchase-headline";

type MerchPrice = { amount: number; currency: string; from?: boolean };

/**
 * What a merch product sells for now, as Link in Bio's merch page reads it:
 * its purchase's items on sale once the purchase is known (LIS-1173; the
 * latest, read again by a checkout), the API's price until then. `price`
 * is null with nothing on sale. `taxAdded`: its seller adds tax at
 * checkout, so the price is before tax ("+ local tax"). `download`: a
 * digital download its store emails (the purchase's delivery `emailed`),
 * as the API says until the purchase is known.
 */
export function merchOnSale(
  access: {
    price: MerchPrice | null;
    deliveryMinor: number | null;
    taxAdded?: boolean;
    download?: boolean;
  },
  purchase: Purchase | null | undefined,
): {
  price: MerchPrice | null;
  deliveryMinor: number | null;
  taxAdded: boolean;
  download: boolean;
} {
  if (purchase === undefined)
    return {
      price: access.price,
      deliveryMinor: access.deliveryMinor,
      taxAdded: access.taxAdded === true,
      download: access.download === true,
    };
  const headline = purchase ? purchaseHeadline(purchase) : null;
  return {
    price: headline?.price ?? null,
    deliveryMinor: headline?.deliveryMinor ?? null,
    taxAdded: purchase?.tax === "added_at_checkout",
    download: purchase?.delivery.kind === "emailed",
  };
}
